export const fonts = [
  'Quicksand',
  'Allerta',
  'Allerta Stencil',
  'Oswald',
  'Roboto Slab',
  'Roboto Mono',
  'Annie use your telescope'
];

export const fontColors = [
  '#000000', 
  '#FFFFFF', 
  '#717D7E', 
  '#8E44AD', 
  '#CB4335', 
  '#52BE80', 
  '#0000CC', 
  '#006633', 
  '#00CCFF', 
  '#9900CC', 
  '#FF00FF', 
  '#FFFF33', 
  '#CCFFFF', 
  '#99CC33', 
  '#66CCFF', 
  '#669966', 
  '#CC6699'
]
